"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var UnattemptedRound_exports = {};
__export(UnattemptedRound_exports, {
  default: () => UnattemptedRound_default
});
module.exports = __toCommonJS(UnattemptedRound_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 3.14971C11.4082 3.14971 10.8305 3.20771 10.2722 3.31817C9.94709 3.38248 9.63143 3.17109 9.56712 2.84602C9.50281 2.52095 9.7142 2.20529 10.0393 2.14099C10.6739 2.01544 11.3296 1.94971 12 1.94971C12.6704 1.94971 13.3261 2.01544 13.9607 2.14099C14.2858 2.20529 14.4972 2.52095 14.4329 2.84602C14.3686 3.17109 14.0529 3.38248 13.7278 3.31817C13.1695 3.20771 12.5918 3.14971 12 3.14971ZM16.752 3.80762C16.9363 3.53226 17.309 3.45848 17.5844 3.64283C18.6801 4.37639 19.6233 5.31964 20.3569 6.41535C20.5412 6.69071 20.4674 7.06337 20.1921 7.24772C19.9167 7.43207 19.5441 7.35829 19.3597 7.08293C18.7134 6.11757 17.8821 5.28629 16.9168 4.63999C16.6414 4.45565 16.5676 4.08298 16.752 3.80762ZM7.24801 3.80762C7.43236 4.08298 7.35858 4.45565 7.08322 4.64C6.11786 5.28629 5.28658 6.11757 4.64028 7.08293C4.45594 7.35829 4.08327 7.43207 3.80791 7.24772C3.53255 7.06337 3.45877 6.69071 3.64312 6.41535C4.37668 5.31964 5.31993 4.37639 6.41564 3.64283C6.69099 3.45849 7.06366 3.53226 7.24801 3.80762ZM2.84631 9.56683C3.17138 9.63114 3.38277 9.9468 3.31846 10.2719C3.208 10.8302 3.15 11.4079 3.15 11.9997C3.15 12.5915 3.208 13.1692 3.31846 13.7275C3.38277 14.0526 3.17138 14.3683 2.84631 14.4326C2.52124 14.4969 2.20558 14.2855 2.14128 13.9604C2.01573 13.3258 1.95 12.6701 1.95 11.9997C1.95 11.3293 2.01573 10.6736 2.14128 10.039C2.20558 9.71391 2.52124 9.50252 2.84631 9.56683ZM21.1537 9.56683C21.4788 9.50252 21.7944 9.71391 21.8587 10.039C21.9843 10.6736 22.05 11.3293 22.05 11.9997C22.05 12.6701 21.9843 13.3258 21.8587 13.9604C21.7944 14.2855 21.4788 14.4969 21.1537 14.4326C20.8286 14.3683 20.6172 14.0526 20.6815 13.7275C20.792 13.1692 20.85 12.5915 20.85 11.9997C20.85 11.4079 20.792 10.8302 20.6815 10.2719C20.6172 9.9468 20.8286 9.63114 21.1537 9.56683ZM20.1921 16.7517C20.4674 16.936 20.5412 17.3087 20.3569 17.5841C19.6233 18.6798 18.6801 19.623 17.5844 20.3566C17.309 20.5409 16.9363 20.4671 16.752 20.1918C16.5676 19.9164 16.6414 19.5438 16.9168 19.3594C17.8821 18.7131 18.7134 17.8818 19.3597 16.9165C19.5441 16.6411 19.9167 16.5673 20.1921 16.7517ZM3.80791 16.7517C4.08327 16.5673 4.45594 16.6411 4.64029 16.9165C5.28658 17.8818 6.11786 18.7131 7.08322 19.3594C7.35858 19.5438 7.43236 19.9164 7.24801 20.1918C7.06366 20.4672 6.691 20.5409 6.41564 20.3566C5.31993 19.623 4.37668 18.6798 3.64312 17.5841C3.45878 17.3087 3.53255 16.936 3.80791 16.7517ZM9.56712 21.1534C9.63143 20.8283 9.94709 20.6169 10.2722 20.6812C10.8305 20.7917 11.4082 20.8497 12 20.8497C12.5918 20.8497 13.1695 20.7917 13.7278 20.6812C14.0529 20.6169 14.3686 20.8283 14.4329 21.1534C14.4972 21.4785 14.2858 21.7941 13.9607 21.8584C13.3261 21.984 12.6704 22.0497 12 22.0497C11.3296 22.0497 10.6739 21.984 10.0393 21.8584C9.7142 21.7941 9.50281 21.4785 9.56712 21.1534Z",
      fill: "currentColor"
    }
  )
);
const SvgUnattemptedRound = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var UnattemptedRound_default = SvgUnattemptedRound;
